export const UPDATE_LOADER = 'UPDATE_LOADER';
